import type { CartItem } from '../types';

/** Minimal cart line for DB tracking — avoids huge product payloads that can fail silently. */
export function serializeCartItemsForTracking(items: CartItem[]) {
  return items.map((item) => {
    const product = item.product ?? ({} as CartItem['product']);
    const start =
      item.startDate instanceof Date ? item.startDate.toISOString() : String(item.startDate ?? '');
    const end =
      item.endDate instanceof Date ? item.endDate.toISOString() : String(item.endDate ?? '');

    return {
      product: {
        id: product.id,
        name: product.name,
        pricePerDay: product.pricePerDay,
        category: product.category,
        slug: product.slug,
        image: product.image ?? (product as { main_image?: string }).main_image ?? null,
      },
      quantity: item.quantity,
      startDate: start,
      endDate: end,
      options: item.options ?? [],
      removedComponents: item.removedComponents ?? [],
      addons: item.addons ?? [],
    };
  });
}
